export default "__VITE_ASSET__BOCtGkK___"